const SET_SELECTED_COST_CENTER = 'SET_SELECTED_COST_CENTER';
const SET_SELECTED_ORDER_TYPE = 'SET_SELECTED_ORDER_TYPE';
const SET_IS_APPROVAL_OVERRIDE = 'SET_IS_APPROVAL_OVERRIDE';
const GET_VEHICLE_TYPE = 'GET_VEHICLE_TYPE';
const SET_VEHICLE_TYPE = 'SET_VEHICLE_TYPE';
const GET_MAKE_LIST = 'GET_MAKE_LIST';
const SET_MAKE_LIST = 'SET_MAKE_LIST';
const GET_VEHICLE_SPEC_LIST = 'GET_VEHICLE_SPEC_LIST';
const SET_VEHICLE_SPEC_LIST = 'SET_VEHICLE_SPEC_LIST';
const SET_ORDER_DATA = 'SET_ORDER_DATA';
const SET_ORDER_CART_DATA = 'SET_ORDER_CART_DATA'
const GET_MANAGED_EQUIPEMENT_TYPES = 'GET_MANAGED_EQUIPEMENT_TYPES'
const SET_MANAGED_EQUIPEMENT_TYPES = 'SET_MANAGED_EQUIPEMENT_TYPES'
const GET_CATALOG_ITEMS = 'GET_CATALOG_ITEMS'
const SET_CATALOG_ITEMS = 'SET_CATALOG_ITEMS'
const UPLOAD_BULK_ORDER_ATTACHMENTS = 'UPLOAD_BULK_ORDER_ATTACHMENTS'
const SET_BULK_ORDER_ATTACHMENTS = 'SET_BULK_ORDER_ATTACHMENTS'
const REMOVE_BULK_ORDER_ATTACHMENT = "REMOVE_ATTACHMENT";
const SHOW_MY_CART_ALERT = "SHOW_MY_CART_ALERT";
const GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN = 'GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN';
const SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN = 'SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN'
const SET_BULK_ORDER_FLEET_ATTACHMENTS = 'SET_BULK_ORDER_FLEET_ATTACHMENTS';
const GET_BULK_ORDER_FLEET_ATTACHMENTS = 'GET_BULK_ORDER_FLEET_ATTACHMENTS'

export {
    SET_SELECTED_COST_CENTER,
    SET_SELECTED_ORDER_TYPE,
    SET_IS_APPROVAL_OVERRIDE,
    GET_VEHICLE_TYPE,
    SET_VEHICLE_TYPE,
    GET_MAKE_LIST,
    SET_MAKE_LIST,
    GET_VEHICLE_SPEC_LIST,
    SET_VEHICLE_SPEC_LIST,
    SET_ORDER_DATA,
    SET_ORDER_CART_DATA,
    GET_MANAGED_EQUIPEMENT_TYPES,
    SET_MANAGED_EQUIPEMENT_TYPES,
    GET_CATALOG_ITEMS,
    SET_CATALOG_ITEMS,
    UPLOAD_BULK_ORDER_ATTACHMENTS,
    SET_BULK_ORDER_ATTACHMENTS,
    REMOVE_BULK_ORDER_ATTACHMENT,
    SHOW_MY_CART_ALERT,
    GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_BULK_ORDER_FLEET_ATTACHMENTS,
    GET_BULK_ORDER_FLEET_ATTACHMENTS
};